import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import { persistenceStats } from '@api/persistence';
import moment from 'moment';
import { saveAs } from '@utils';

const TS_FORMAT = 'MMM-DD-YYYY_HH:mm:ss';

const Wrapper = styled.div`
  width: 100%;
`;

function Summary({ persistenceKey, data }) {
  const handleClick = async () => {
    const resp = await persistenceStats({ exportData: true });
    const filename = `persistence_report_${moment().format(TS_FORMAT)}.csv`;
    saveAs(resp.data, filename);
  };

  const cardMap = {
    '/': TrendsCard,
    '/noc': NocCard,
  };
  const Card = cardMap[persistenceKey];

  return (
    <Wrapper>
      <Card data={data} handleClick={handleClick} />
    </Wrapper>
  );
}

function TrendsCard({ data, handleClick }) {
  return (
    <Card
      title="Summary"
      style={{ width: 300 }}
      extra={<a onClick={handleClick}>Download</a>}
    >
      <div>
        No of Records:
        {' '}
        <strong>{data.noOfRecords}</strong>
        {' '}
      </div>
      <div>
        DoD Enabled:
        {' '}
        <strong>{data.dodEnabledCount}</strong>
        {' '}
      </div>
      <div>
        Panel Metrics(average):
        {' '}
        <strong>{Math.round(data.panelMetricsAverage)}</strong>
        {' '}
      </div>
    </Card>
  );
}

function NocCard({ data, handleClick }) {
  return (
    <Card
      title="Summary"
      style={{ width: 300 }}
      extra={<a onClick={handleClick}>Download</a>}
    >
      <div>
        No of Records:
        {' '}
        <strong>{data.noOfRecords}</strong>
        {' '}
      </div>
      <div>
        Trends View Metrics (avg):
        {' '}
        <strong>{data.avgTrendsViewMetrics}</strong>
        {' '}
      </div>
      <div>
        Filters View Metrics (avg):
        {' '}
        <strong>{data.avgFiltersViewMetrics}</strong>
        {' '}
      </div>
      <div>
        Applied Filters (avg):
        {' '}
        <strong>{data.avgAppliedFilters}</strong>
        {' '}
      </div>
    </Card>
  );
}

export default Summary;
